import { Box, Grid } from '@mui/material'
import React, { ReactNode, useEffect } from 'react'
import LeftSide from '../../Screens/Auth/LeftSide'
import { useSelector } from 'react-redux';
import { RootState } from '../../Redux/store';
import { useLocation, useNavigate } from 'react-router-dom';


interface MainLayoutProps {
    children: ReactNode;
}

function AuthLayout({ children }: MainLayoutProps) {
    const { userDetails } = useSelector((state: RootState) => state.global)
    const navigate = useNavigate()
    const location = useLocation()

    useEffect(() => {
        if (userDetails) {
            navigate(-1)
        }
    }, [location.pathname])
    return (
        <Box className='d-flex bg-black overflow-hidden gap-0 w-100' sx={{ height: '100dvh' }}>
            <Grid container className='w-100 h-100'>
                <Grid size={{ xs: 12, lg: 6 }} className='h-100 d-none d-xl-inline-block'>
                    <Box className='h-100'>
                        <LeftSide />
                    </Box>
                </Grid>
                <Grid size={{ xs: 12, lg: 6 }} className='h-100 d-inline-block'>
                    <Box className='h-100'>
                        {children}
                    </Box>
                </Grid>
            </Grid>
            {/* <Box sx={{ flex: 1, overflowX: 'hidden !important' }} className='d-flex h-100 overflow-hidden  flex-column'>

            </Box> */}
        </Box>
    )
}

export default AuthLayout
